import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/check-badge-success.svg")